import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { AlertAndNotification } from 'src/types/alertAndNotification';
import { AlertNotification } from 'src/types/alertNotification';
import genericActions, { genericMockActions } from './common';

export interface ReduxStoreObject {
  records?: AlertAndNotification[];
  selectedRecord?: AlertNotification;
  recordsForDropdown?: AlertAndNotification[];
  error: boolean;
  success: boolean;
  message: string;
  loading: boolean;
  actionType?: string;
}
const emptyObject = {
  id: 0,
  event: '',
  enable: false,
  alertType: [],
  users: []
};

const initialState: ReduxStoreObject = {
  records: [],
  selectedRecord: emptyObject,
  recordsForDropdown: [],
  error: false,
  success: false,
  message: '',
  loading: false,
  actionType: '',
};

const slice = createSlice({
  name: 'alertsAndNotifications',
  initialState,
  reducers: {
    getAll(state: ReduxStoreObject, action: PayloadAction<ReduxStoreObject>) {
      const { records, error, message, loading } = action.payload;

      state.records = records;
      state.error = error;
      state.message = message;
      state.loading = loading;
      state.actionType = 'getAll';
    },
    getAllForDropdown(state: ReduxStoreObject, action: PayloadAction<ReduxStoreObject>) {
      const { records, error, message, loading } = action.payload;

      state.recordsForDropdown = records;
      state.error = error;
      state.message = message;
      state.loading = loading;
      state.actionType = 'getAllForDropdown';
    },
    get(state: ReduxStoreObject, action: PayloadAction<ReduxStoreObject>) {
      const { selectedRecord: clientSelected, error, message, loading } = action.payload;

      if (clientSelected) {
        state.selectedRecord = clientSelected;
        state.error = error;
        state.message = message;
        state.loading = loading;
        state.actionType = 'get';
      }
    },
    set(state: ReduxStoreObject, action: PayloadAction<{ error: boolean; success: boolean; message: string; loading: boolean; }>) {
      const { success, error, message, loading } = action.payload;
      state.error = error;
      state.success = success;
      state.message = message;
      state.actionType = 'set';
      if (loading !== null)
        state.loading = loading;
    },
    remove(state: ReduxStoreObject, action: PayloadAction<{ error: boolean; success: boolean; message: string; loading: boolean; }>) {
      const { success, error, message, loading } = action.payload;
      state.error = error;
      state.success = success;
      state.message = message;
      state.loading = loading;
      state.actionType = 'remove';
    },
    resetError(state: ReduxStoreObject) {
      state.error = false;
      state.message = '';
      state.actionType = 'resetError';
    },
    resetSuccess(state: ReduxStoreObject) {
      state.success = false;
      state.message = '';
      state.actionType = 'resetSuccess';
    },
    setLoading(state: ReduxStoreObject, action: PayloadAction<{ loading: boolean; }>) {
      const { loading } = action.payload;
      state.loading = loading;
      state.actionType = 'loading';
    },
    resetSelected(state: ReduxStoreObject) {
      state.selectedRecord = emptyObject;
    }
  }
});

export const reducer = slice.reducer;

export const { getAll, getAllForDropdown, get, set, put, patch, remove, resetError, resetSuccess } = genericActions(slice.actions, 'AlertNotifications', emptyObject);
export const { get: getMock } = genericMockActions(slice.actions, 'alertsAndNotifications', emptyObject);
export default slice;